import React, { useState } from "react";
import { useInterval } from "src/shared/hooks";
import { message, notification } from "antd";
import { BANNER_API_REFRESH_INTERVAL } from "src/shared/config";
import { NotificationType } from "src/shared/types";
import "./styles.scss";

// Antd doesn't support closing the notification programatically. So only way to close them is using timeout
const BANNER_INTERVAL = BANNER_API_REFRESH_INTERVAL - 0.9;

interface RetryComponentProps {
  notificationText: string;
  type: NotificationType;
}

const RetryComponent = ({ notificationText, type }: RetryComponentProps) => {
  const [timer, setTimer] = useState(Math.floor(BANNER_INTERVAL));
  const isErrorType = type.toLowerCase() === NotificationType.ERROR;

  useInterval(
    () => {
      setTimer((prev) => prev - 1);
    },
    timer > 0 && isErrorType ? 1000 : null
  ); // 1 sec

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: notificationText }} />
      {isErrorType && <div className="banner-retry">Retrying in {timer} sec</div>}
    </>
  );
};

const setAlert = (type: "success" | "error", alertText: string): void => {
  if (type === "success") {
    message.success(alertText);
  } else {
    message.error(alertText);
  }
};

const getNotificationConfig = (notificationText: string, type: NotificationType, key = "1") => ({
  duration: BANNER_INTERVAL,
  placement: "topRight" as const,
  message: <RetryComponent notificationText={notificationText} type={type} />,
  /**
   * Same key for all notifications because we will be showing only single notification at a time
   * having same key will overwrite the existing notification
   */
  key,
});

const setNotification = (type: NotificationType, notificationText: string): void => {
  if (type.toLocaleLowerCase() === NotificationType.SUCCESS) {
    notification.success(getNotificationConfig(notificationText, type));
  } else if (type.toLocaleLowerCase() === NotificationType.ERROR) {
    notification.error(getNotificationConfig(notificationText, type));
  } else {
    notification.info(getNotificationConfig(notificationText, type));
  }
};

export { setAlert, setNotification };
